import { AxiosResponse } from "axios";
import Cookies from "js-cookie";
import * as Yup from "yup";
import { endpoints } from "../constants/api";
import { $http } from "../config/axiosConfig";
import { clientSchema } from "../schemas/client.schema";

export const fetchClientsAsync = async () => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.get(`${endpoints.allClients}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const createClientAsync = async ({
  values,
}: {
  values: Yup.InferType<typeof clientSchema>;
}) => {
  const isValidFields = await clientSchema.isValid(values);

  if (isValidFields) {
    const token = Cookies.get("token");

    const payload = {
      name: values.name,
      email: values.email,
      contacts: values.contacts,
      password: values.password,
    };

    try {
      const data: AxiosResponse = await $http.post(
        endpoints.addClient,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return { data: data?.data };
    } catch (error) {
      return error;
    }
  } else {
    return new Response("Invalid fields!", { status: 400 });
  }
};
